// extracted by mini-css-extract-plugin
export var appStore = "svg-module--app-store--QWweW";
export var component = "svg-module--component--epBUv";
export var light = "svg-module--light--DlbHK";
export var ps4 = "svg-module--ps4--kdOAc";
export var steam = "svg-module--steam--LZhRP";
export var xboxOne = "svg-module--xboxOne--LJF+I";